// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.profile.HpApiUserProfileV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { HpApiResponseDto, HpUserProfileDto, HpUserProfileUpdateRequestDto } from '../..';

export const HpApiUserProfileV3Handler_update_Path = '/api/web/v3/user/profile/update';

/**
 * Update the authenticated user's profile
 */
export const HpApiUserProfileV3Handler_update = (postData: HpUserProfileUpdateRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpUserProfileUpdateRequestDto, HpApiResponseDto<HpUserProfileDto>>(
    {
      endpoint: HpApiUserProfileV3Handler_update_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
